export const defaultExcludeToday = true;

export const defaultDateRangeParams = {
  dateUnit: '範囲選択' as const,
  dateRange: '過去28日' as const,
  comparisonSection: '過去28日' as const,
};
